import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { Container } from "reactstrap";
import $ from "jquery";

export default class Home extends Component {
    constructor() {
        super();
        this.state = {
            xs: 6
        };
    }
    componentWillMount = () => {
        if ($(window).width() < 622) this.setState({ xs: 12 });
        $(window).resize(_ => {
            if ($(window).width() < 622) this.setState({ xs: 12 });
            else this.setState({ xs: 6 });
        });
    }
    render() {
        return (
            <Container style={styles.homeContinaer} className="homeContainer">
                <div className="container">
                    <Row style={{ marginBottom: 20 }}>
                        <Col xs={this.state.xs} sm={6} md={6}>
                            <Row>
                                <Col xs={2} sm={2} md={1}>
                                    <i style={styles.icon} className="fas fa-users users_icon icons"></i>
                                </Col>
                                <Col xs={9} sm={10} md={10}>
                                    <div style={styles.homeInfo} className="homeInfo">
                                        <p style={styles.homeInfoHeading}>USERSTORY</p>
                                        <p style={styles.homeInfoPara}>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={this.state.xs} sm={6} md={6}>
                            <Row>
                                <Col xs={2} sm={2} md={1}>
                                    <i className="fas fa-building icons" style={styles.icon}></i>
                                </Col>
                                <Col xs={9} sm={10} md={10}>
                                    <div style={styles.homeInfo} className="homeInfo">
                                        <p style={styles.homeInfoHeading}>WIREFRAME</p>
                                        <p style={styles.homeInfoPara}>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={this.state.xs} sm={6} md={6}>
                            <Row>
                                <Col xs={2} sm={2} md={1}>
                                    <i style={styles.icon} className="fas fa-pencil-alt icons"></i>
                                </Col>
                                <Col xs={9} sm={10} md={10}>
                                    <div style={styles.homeInfo} className="homeInfo">
                                        <p style={styles.homeInfoHeading}>GRAPHIC DESIGN</p>
                                        <p style={styles.homeInfoPara}>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col xs={this.state.xs} sm={6} md={6}>
                            <Row>
                                <Col xs={2} sm={2} md={1}>
                                    <i className="fas fa-globe icons" style={styles.icon}></i>
                                </Col>
                                <Col xs={9} sm={10} md={10}>
                                    <div style={styles.homeInfo} className="homeInfo">
                                        <p style={styles.homeInfoHeading}>WEB DEVELOPMENT</p>
                                        <p style={styles.homeInfoPara}>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation</p>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Container>
        );
    }
}
const styles = {
    homeContinaer: {
        backgroundColor: "#0C0A09",
        height: 500,
        width: "100%",
        color: "#fff",
        padding: "50px 0px"
    },
    icon: {
        color: "#3E3E3E",
        fontSize: 40,
        transition: "all .20s ease"
    },
    userIcon: {
        marginRight: 5
    },
    homeInfo: {
        backgroundColor: "#232323",
        height: 175,
        width: "100%",
        fontFamily: "Roboto, sans-serif",
        border: "1px dashed #4A4A4A",
        padding: 20,
        transition: "all .20s ease"
    },
    homeInfoHeading: {
        fontSize: 20,
        color: "#fff"
    },
    homeInfoPara: {
        fontSize: 15,
        color: "#929292"
    }
};


// WEBPACK FOOTER //
// ./src/Components/home.jsx